import { gql } from '@apollo/client';

import {
  formFieldFragment,
  makeLocationFieldsFragment,
} from './commonFragments';

const locationFieldsFragment = makeLocationFieldsFragment();
export const QUOTE_FORM_SCHEMA_QUERY = gql`
  query QuoteFormSchemaQuery($accountNumber: String!) {
    newQuoteFormSchema(accountNumber: $accountNumber) {
      pickupDateTime ${formFieldFragment}
      origin ${locationFieldsFragment}
      destination ${locationFieldsFragment}
      serviceInformation {
        serviceType ${formFieldFragment}
        commodity ${formFieldFragment}
        dangerousGoods ${formFieldFragment}
        exceptedQuantity ${formFieldFragment}
        unNumber ${formFieldFragment}
      }
      packages {
        packageSource ${formFieldFragment}
        packagingType ${formFieldFragment}
        actualWeight ${formFieldFragment}
        length ${formFieldFragment}
        width ${formFieldFragment}
        height ${formFieldFragment}
      }
    }
  }
`;

export const QUOTE_FORM_AUTOFILL_QUERY = gql`
  query QuoteFormAutofillQuery($input: AsyncFieldAutofillInput!) {
    newQuoteFieldAutofill(input: $input) {
      value
    }
  }
`;
